var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 30,
    viewBox: "0 0 63 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4392 21.7489C52.136 29.2483 13.136 31.2486 3.43923 21.7489C2.41779 20.7483 -3.76077 4.54894 3.43923 1.74893C12.4392 -1.75107 22.4392 0.952175 30.9392 1.74893C35.4392 1.53524 48.9392 -1.25107 58.4392 1.74893C66.0392 4.14894 59.28 20.7483 58.4392 21.7489Z",
    fill: "#DE9079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0117 10.7483C18.8615 10.7483 9.01172 14.9683 9.01172 22.7483L53.0117 22.7483C53.0117 14.9683 43.162 10.7483 31.0117 10.7483Z",
    fill: "#D67A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4747 1.38635C55.6194 6.82175 44.5046 9.7482 32.0741 9.7482C19.1622 9.7482 6.94696 6.79005 5.01172 1.29807C11.686 -0.860327 18.8368 0.123102 25.4738 1.03586C27.4522 1.30796 29.385 1.57377 31.2459 1.7482C32.2331 1.70133 33.6534 1.53064 35.3696 1.32439C41.1336 0.631693 50.2352 -0.462105 57.4747 1.38635Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0122 24.4336C49.9376 27.9677 41.0868 29.8417 31.417 29.8417C21.0998 29.8417 11.2402 27.8431 7.01172 24.0815C7.96382 19.2613 14.5088 20.1003 21.7835 21.0329C24.7141 21.4086 27.7631 21.7995 30.6127 21.8417C33.447 21.8417 36.4722 21.5528 39.375 21.2756C46.7103 20.5752 53.2639 19.9493 53.9804 24.2482C53.9908 24.3102 54.0014 24.372 54.0122 24.4336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthM);
export default __webpack_public_path__ + "static/media/Mouth M.0fd719eb23ab6a6f22e1474eb5d9d96c.svg";
export { ForwardRef as ReactComponent };